import {SelectedTimeSlot, TimeSlotUtil} from "@/utils/timeslot.util";
import {Exception, OpeningHours, OpeningTimes} from "@/services/location.service";
import InputDatePicker from "../input-date-picker/InputDatePicker"
import InputButton from "../input-button/InputButton"
import * as moment from 'moment-timezone'
export default {
    name: 'OpeningHoursSelector',
    components: {
        InputDatePicker,
        InputButton
    },

    props: {
        value: OpeningHours,
        input: Object,
        startTime: String,
        endTime: String,
        exceptionsOnly: false

    },
    created() {
        this.openingHours = this.value ? this.value : new OpeningHours()
        this.start = this.startTime ? this.startTime : "00:00"
        this.end = this.endTime ? this.endTime : "23:59"
        this.inputOpeningHours = this.input ? this.input : undefined

    },

    data() {
        return {
            width: 0,
            timeSlots: [],
            exceptionTimeSlots: [],
            days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
            start: "00:00",
            end: "23:59",
            inputOpeningHours: Object,
            openingHours: new OpeningHours(),
            selectedTimeRange: new SelectedTimeSlot(),
            selectedExceptionRange: new SelectedTimeSlot(),
            exception: [],
            exceptionDate: new Date()
        }
    },

    mounted() {
        this.initOpeningHours()
        this.createTimeslots()
        if (this.inputOpeningHours !==  undefined) {
            this.convert(this.inputOpeningHours)
        }
    },

    methods: {

        convertTimeslots(times) {
            let timeslots = []
            // for every closing interval
            for (let interval of times) {
                const startTime = TimeSlotUtil.getTimeSlotTime(interval.from) // create the start time
                // subtract 15min since we only need the timeslots till the endtime - 15min
                let dateStr = new Date().toISOString(),
                    date    = moment(dateStr),
                    time    = moment(interval.to, 'HH:mm').subtract(15, 'minutes');

                date.set({
                    hour:   time.get('hour'),
                    minute: time.get('minute'),
                    second: time.get('second')
                });

                let end = date.toDate().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', hour12: false})

                const endTime = TimeSlotUtil.getTimeSlotTime(end != "00:00" ? end : "23:59") // create the end time
                let arr = TimeSlotUtil.createTimeSlots(startTime, endTime, 15, false) // generate timeslots
                timeslots = timeslots.concat(arr) // add the timeslots
            }
            return timeslots
        },

        /**
         * function that translates openingHours object to timeslots
         * @param openingHours
         */
        convert(openingHours){
            let defaultWeek = openingHours.defaultWeek

            // for every day
            for (let day = 0; day < 7; day ++) {
                let times = defaultWeek[day].times //get the times
                let timeslots = this.convertTimeslots(times)
                this.openingHours.defaultWeek[day].times = this.timeSlots[day].filter(slot => timeslots.map(t => t.hours+":"+t.minutes).includes(slot.hours+":"+slot.minutes)) // match the generated timeslots to the exisiting timeslots to have the right indexes

            }

            // convert  Exceptions

            let exceptions = openingHours.exceptions
            for (let i = 0; i < exceptions.length; i ++) {
                let exception = exceptions[i]
                let times = exception.times
                let timeslots = this.convertTimeslots(times)
                exception.times = this.exceptionTimeSlots.filter(slot => timeslots.map(t => t.hours+":"+t.minutes).includes(slot.hours+":"+slot.minutes)) // match the generated timeslots to the exisiting timeslots to have the right indexes
                exception.date = new Date(exception.date)
                this.openingHours.exceptions.push(exception)
            }
        },

        /**
         * Initializes empty objects
         * Adds days
         */
        initOpeningHours() {
            this.openingHours.defaultWeek = Array.from(new Array(7), (val, index) => {
                let openingTimes = {
                    day: this.days[index],
                    times: []
                }
                let obj = new OpeningTimes(openingTimes)
                return obj
            })

            this.openingHours.exceptions = []
        },

        /**
         * Creates the timeslots that can be selected
         */
        createTimeslots() {
            const startTime = TimeSlotUtil.getTimeSlotTime(this.start)
            const endTime = TimeSlotUtil.getTimeSlotTime(this.end)

            for (let day of this.days) {
                this.timeSlots.push(TimeSlotUtil.createTimeSlots(startTime, endTime, 15, false))
            }
            this.exceptionTimeSlots = TimeSlotUtil.createTimeSlots(startTime, endTime, 15, false)
            this.width = this.timeSlots[0].length
        },

        /**
         * Function that runs after selecting a timeslot
         * @param dayIndex
         * @param timeslotIndex
         */
        selectTimeSlot (dayIndex, timeslotIndex) {
            if (timeslotIndex == this.selectedTimeRange.startIndex && this.selectedTimeRange.entityIndex == dayIndex) {
                this.selectedTimeRange.endIndex = undefined
                this.updateTimeSlots(true)
                return
            }

            const changedDay = this.selectedTimeRange.entityIndex != dayIndex
            if (changedDay || this.selectedTimeRange.endIndex) {
                this.selectedTimeRange.startIndex = undefined
                this.selectedTimeRange.endIndex = undefined
            }
            this.selectedTimeRange.entityIndex = dayIndex

            if (this.selectedTimeRange.startIndex == undefined) {
                this.selectedTimeRange.startIndex = timeslotIndex
            } else if (this.selectedTimeRange.endIndex == undefined) {
                this.selectedTimeRange.endIndex = timeslotIndex
            }

            this.updateTimeSlots(true)

        },

        /**
         * Function that runs after selecting a timeslot in the exceptions selector
         * @param timeSlotIndex
         */
        selectExceptionTimeSlot(timeSlotIndex) {

            if (timeSlotIndex == this.selectedExceptionRange.startIndex) {
                this.selectedExceptionRange.endIndex = undefined
                this.updateExceptionTimeSlots(true)
                return
            }

            if (this.selectedExceptionRange.endIndex) {
                this.selectedExceptionRange.startIndex = undefined
                this.selectedExceptionRange.endIndex = undefined
            }

            if (this.selectedExceptionRange.startIndex == undefined) {
                this.selectedExceptionRange.startIndex = timeSlotIndex
            } else if (this.selectedExceptionRange.endIndex == undefined) {
                this.selectedExceptionRange.endIndex = timeSlotIndex
            }

            this.updateExceptionTimeSlots(true)

        },

        /**
         * update timeslots
         * @param active
         */
        updateExceptionTimeSlots(active) {
            const startIndex = this.selectedExceptionRange.startIndex
            const endIndex = this.selectedExceptionRange.endIndex == undefined ? startIndex : this.selectedExceptionRange.endIndex

            if (endIndex < startIndex) {
                this.selectedExceptionRange.startIndex = endIndex
                this.selectedExceptionRange.endIndex = startIndex
                this.updateExceptionTimeSlots(true)
            }else{
                for (let i = startIndex; i <= endIndex; i++) {
                    const activeTimeSlot = this.exceptionTimeSlots[i]
                    activeTimeSlot.isActive = active
                    this.exception.push(activeTimeSlot)
                }
                this.cleanExceptionHours()
            }
        },

        updateTimeSlots(active) {
            const startIndex = this.selectedTimeRange.startIndex
            const endIndex = this.selectedTimeRange.endIndex == undefined ? startIndex : this.selectedTimeRange.endIndex

            if (endIndex < startIndex) {
                this.selectedTimeRange.startIndex = endIndex
                this.selectedTimeRange.endIndex = startIndex
                this.updateTimeSlots(true)
            }else{
                for (let i = startIndex; i <= endIndex; i++) {
                    const activeTimeSlot = this.timeSlots[this.selectedTimeRange.entityIndex][i]
                    activeTimeSlot.isActive = active
                    this.openingHours.defaultWeek[this.selectedTimeRange.entityIndex].times.push(activeTimeSlot)
                }
                this.cleanOpeningHours()
            }
        },

        clearOpeningHours(dayIndex) {
            this.selectedTimeRange = new SelectedTimeSlot()
            this.openingHours.defaultWeek[dayIndex].times = []
        },

        cleanOpeningHours() {
            for (let i = 0; i <= this.openingHours.defaultWeek.length; i ++) {
                let timeslots = this.openingHours.defaultWeek[i]
                if (timeslots != undefined) {
                    timeslots = _.uniq(timeslots.times)
                    timeslots = _.sortBy(timeslots, o => o.index)
                    this.openingHours.defaultWeek[i].times = timeslots
                }
            }
        },

        cleanExceptionHours() {
            this.exception = _.uniq(this.exception)
            this.exception = _.sortBy(this.exception, o => o.index)


        },

        isTimeSlotClosed (dayIndex, timeslotIndex) {
            if (this.selectedTimeRange.entityIndex == dayIndex &&
                timeslotIndex >= this.selectedTimeRange.startIndex && timeslotIndex <= this.selectedTimeRange.endIndex) {
                return true
            } else if (this.openingHours.defaultWeek[dayIndex].times.includes(this.timeSlots[dayIndex][timeslotIndex])) {
                return true
            }
        },

        isTimeslotClosedException(timeslotIndex) {
            if (timeslotIndex >= this.selectedExceptionRange.startIndex && timeslotIndex <= this.selectedExceptionRange.endIndex) {
                return true
            } else if (this.exception.includes(this.exceptionTimeSlots[timeslotIndex])) {
                return true
            }
        },

        updateExceptionDate(date) {
            this.exceptionDate = date
        },

        isException(index, exception) {
          if (exception.times.includes(this.exceptionTimeSlots[index])) {
              return true
          }
        },

        doAdd() {
            let exc = {
                date: this.exceptionDate.toISOString(),
                times: this.exception
            }
            let exception = new Exception(exc)
            this.openingHours.exceptions.push(exception)
            this.openingHours.exceptions =_.sortBy(this.openingHours.exceptions, e => e.date)
            this.clearEntry()

        },

        clearEntry(){
            this.exceptionDate = new Date()
            this.exception = []
            this.selectedExceptionRange = new SelectedTimeSlot()
        },

        deleteException(exception) {
            this.openingHours.exceptions = this.openingHours.exceptions.filter(e => e != exception)
        }
    }
}
